const TOKEN_SYNONYMS = Object.freeze({
  stock: 'stocks',
  stocks: 'stocks',
  equity: 'stocks',
  equities: 'stocks',
  option: 'options',
  options: 'options',
  index: 'indexes',
  indexes: 'indexes',
  indices: 'indexes',
  crypto: 'crypto',
  cryptos: 'crypto',
  cryptocurrency: 'crypto',
  cryptocurrencies: 'crypto',
  future: 'futures',
  futures: 'futures',
  forex: 'forex',
});

export const CANONICAL_ASSET_TOKENS = Object.freeze([
  'stocks',
  'options',
  'indexes',
  'futures',
  'crypto',
  'forex',
]);

export const CANONICAL_ASSET_TOKEN_SET = new Set(CANONICAL_ASSET_TOKENS);

const REQUIREMENT_LABELS = Object.freeze({
  stocks: 'Stocks',
  options: 'Options',
  indexes: 'Indexes',
  futures: 'Futures',
  crypto: 'Crypto',
  forex: 'Forex',
});

export const REQUIREMENT_DISPLAY_ORDER = Object.freeze(CANONICAL_ASSET_TOKENS);

export const normalizeAssetToken = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }
  const trimmed = value.trim().toLowerCase();
  if (!trimmed) {
    return '';
  }
  const mapped = TOKEN_SYNONYMS[trimmed] || trimmed;
  if (CANONICAL_ASSET_TOKEN_SET.has(mapped)) {
    return mapped;
  }
  // If this isn't one of our supported tokens, return empty so callers can drop it.
  return '';
};

export const formatAssetTokenLabel = (token) => {
  if (!token) return '';
  const normalized = normalizeAssetToken(token);
  if (REQUIREMENT_LABELS[normalized]) {
    return REQUIREMENT_LABELS[normalized];
  }
  return token
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ');
};

export const getAssetPillClass = (token) => {
  const normalized = normalizeAssetToken(token);
  if (!normalized) {
    return 'pill--default';
  }
  return `pill--${normalized}`;
};

export const formatAssetList = (labels = []) => {
  if (!Array.isArray(labels) || labels.length === 0) return '';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  const leading = labels.slice(0, -1).join(', ');
  return `${leading}, and ${labels[labels.length - 1]}`;
};

export const dedupeOrderedAssetTokens = (tokens = []) => {
  const seen = new Set();
  const ordered = [];
  tokens.forEach((token) => {
    const normalized = normalizeAssetToken(token);
    if (!normalized || seen.has(normalized)) return;
    seen.add(normalized);
    ordered.push(normalized);
  });
  return ordered;
};
